import { useRouter } from "next/router";
import { env } from "next-runtime-env";

import { CanvasWindow } from "env";

import { GTM, GTMNoScript } from "../../../packages/gtm/dist";

declare const window: CanvasWindow;

export const pageview = (url: string) => {
  (window.dataLayer || []).push({
    event: "pageview",
    page: url,
  });
};

type GtmAdapterProps = {
  type: string;
};

/**
 * while we use a common GTM tag to load the GTM script and configure the various tracking
 * models used for the site, it's handy to define a single place for environment injection
 * to the GTM component
 *
 * something to note is that you may see this tag fire off twice while developing, this is
 * to do with Next's strict react mode configuration: https://github.com/vercel/next.js/issues/35822
 * this is only an issue with development and doesn't happen in staging nor prod
 *
 * TODO: ideally, this exists in a layout so we don't have to include this component in all
 * canvas pages. Unfortunately, how the rendering works would require some more digging, so
 * going simple for now
 */
export function GtmAdapter({ type }: GtmAdapterProps) {
  const router = useRouter();

  const gtmHost = env("NEXT_PUBLIC_GTM_HOST");
  const gtmContainerId = env("NEXT_PUBLIC_GTM_CONTAINER_ID");
  const gtmParams = env("NEXT_PUBLIC_GTM_PARAMS");

  if (!gtmHost || !gtmContainerId) {
    return null;
  }

  const marketplaceIdentifier = router.query.marketplace;

  return (
    <>
      <GTM
        containerId={gtmContainerId}
        ecommerceEndpoint={`/${marketplaceIdentifier || "us"}/data/ecommerce`}
        host={gtmHost}
        query={gtmParams}
        reportErrorEndpoint={`/report-error`}
        initialDataLayer={[
          {
            app: "pdc",
            country: String(marketplaceIdentifier).toUpperCase(),
            type,
          },
        ]}
      />

      <GTMNoScript
        containerId={gtmContainerId}
        host={gtmHost}
        query={gtmParams}
      />
    </>
  );
}
